import * as currencies from "@dinero.js/currencies";
import { dinero, toDecimal } from "dinero.js";
import type { ChangeEvent } from "react";

export const formatPrice = (
	amount?: number,
	currency?: string,
	symbol?: string,
) => {
	if (amount === undefined || currency === undefined) {
		return `0.00 ${symbol || ""}`;
	}

	// Dinero only takes whole cents. Round to the nearest one rather than up:
	// ceiling every fractional amount inflated each printed total by a cent.
	return toDecimal(
		dinero({
			amount: Math.round(amount),
			// The currency comes from the API, so any of them can be needed: the
			// whole table is bundled on purpose.
			// biome-ignore lint/performance/noDynamicNamespaceImportAccess: see above
			currency: currencies[currency.toUpperCase()],
		}),
		({ value, currency }) => `${value} ${symbol || currency.code}`,
	);
};

export const formatPriceCentsInput = (e: ChangeEvent<HTMLInputElement>) => {
	if (e.target.value === "") {
		return null;
	}

	return Math.round(Number(e.target.value) * 100);
};

export const formatPriceCentsInputValue = (
	value: number | undefined | null,
) => {
	if (typeof value === "number") {
		return value / 100;
	}

	return "";
};

export const formatNumberInput = (e: ChangeEvent<HTMLInputElement>) => {
	if (e.target.value === "") {
		return null;
	}

	return Number(e.target.value);
};
